<template>
  <div style="position: relative; padding-top: 56.25%; width: 100%;">
    <template v-if="source === 'kinescope'">
      <iframe :src="link"
              allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
              frameborder="0"
              style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
              allowfullscreen>
      </iframe>
    </template>

    <template v-else-if="source === 'bunny'">
      <iframe :src="link"
              loading="lazy"
              style="border: 0; position: absolute; top: 0; height: 100%; width: 100%;" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
              allowfullscreen>
      </iframe>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    source: String,
    link: String,
  },
}
</script>
